import React from "react";
import "./index.scss";
import { Tooltip } from "devextreme-react/tooltip"; 
import { IMdaeTooltipProps } from "./index";
import {
  DX_WIDGET_NAMES,
  configureMdaeWidgetOptionUpdaters,
} from "../../mdae-framework";
import { useDispatch } from "react-redux";
const MdaeTooltip: React.FC<IMdaeTooltipProps> = (props) => {
  const dispatch = useDispatch();
  return (
    <div className={"sys-mdae-tooltip-container"}>
      <Tooltip
        {...props}
        onInitialized={(e) => {
          if (typeof props.onInitialized === "function") props.onInitialized(e);
          configureMdaeWidgetOptionUpdaters(
            props.mdaeDataUpdaterConfig,
            DX_WIDGET_NAMES.DX_TOOLTIP,
            e.component,
            dispatch
          );
        }}
      >{props.children}</Tooltip>
    </div>
  );
};
export default MdaeTooltip;
